import {
  useYandexAdsContextSelector,
  YandexAdsContextCommonSelectors,
} from '../YandexAdsContext';
import {AdFoxEventsSender} from './AdFoxEventsSender';
import YandexAdScript from './YandexAdsScript';

export const Controller = () => {
  const activeAdTypes = useYandexAdsContextSelector(
    YandexAdsContextCommonSelectors.getActiveAdTypes,
  );

  if (activeAdTypes.length === 0) {
    return null;
  }
  return (
    <>
      <YandexAdScript />
      {activeAdTypes.includes('adfox') && <AdFoxEventsSender />}
    </>
  );
};
